import { ValueOf } from 'type-fest';

export const EVM_CHAINS = {
  ETHEREUM: 'Ethereum',
  BASE: 'Base',
  ARBITRUM: 'Arbitrum',
  BSC: 'BSC',
} as const;

export type EVMChainType = ValueOf<typeof EVM_CHAINS>;

export const ALEO_CHAINS = {
  ALEO: 'Aleo',
} as const;

export type AleoChainType = ValueOf<typeof ALEO_CHAINS>;

export const NETWORK_TYPES = {
  MAINNET: 'mainnet',
  TESTNET: 'testnet',
} as const;

export type tNetworkTypes = ValueOf<typeof NETWORK_TYPES>;

export type SupportedChainsType = EVMChainType | AleoChainType;

export type EVMChainConfig = Record<tNetworkTypes, EVMChainInfo>;
export type EVMChainConfigs = Record<EVMChainType, EVMChainConfig>;

export type EVMChainInfo = {
  chainId: number;
  name: string;
  currency: string;
  explorerUrl: string;
  rpcUrl: string;
  shortName: string;
};
